<template>

    <teleport to="#modal">
        <Loading
            :visible="loading"
        >
        </Loading>
    </teleport>

    <div class="m-auto px-8 md:px-20 pb-8">
        <div class="max-w-screen-2xl m-auto">
            <div class="pt-10 pb-5 flex justify-between">
                <Breadcrumbs :paths="getBreadcrumbsPath"></Breadcrumbs>
            </div>

            <div class="flex items-center pb-10">
                <BadgeStato :stato="sottoprogetto?.stato"></BadgeStato>
            </div>

            <div class="mb-5">
                <div class="text-3xl font-bold flex justify-between">
                    <span>{{ sottoprogetto?.titolo }}</span>
                    <span>{{ sottoprogetto?.cod_nodo }}</span>
                </div>
                <div class="flex justify-between">
                    <div>
                        <small>Da <span class="font-bold">{{
                            sottoprogetto?.data_inizio ? $filters.toDate(sottoprogetto?.data_inizio) : '-'
                        }}</span> a
                        <span class="font-bold">{{
                                sottoprogetto?.data_fine ? $filters.toDate(sottoprogetto?.data_fine) : '-'
                            }}</span></small>
                    </div>
                    <Checkbox
                        checkClass="h-3 w-3"
                        :checked="solo_manuali"
                        @change="onToggleManuali"
                    >
                        Mostra solo versioni manuali
                    </Checkbox>
                </div>
            </div>
            <SottoProgettoHead
                :budget="sottoprogetto.budget ? `${$filters.toEuroCurrency(Number(sottoprogetto.budget))}` : '-'"
                :totaleRicavi="ActiveTab && TotaleRicaviProgetto(ActiveTab.sezioni) ? $filters.toEuroCurrency(TotaleRicaviProgetto(ActiveTab.sezioni)) : '-'"
                :budgetProgetto="ActiveTab && TotaleBudgetProgetto(ActiveTab.sezioni) ? $filters.toEuroCurrency(TotaleBudgetProgetto(ActiveTab.sezioni)) : '-'"
                :commissioni="ActiveTab && TotaleCommissioniProgetto(ActiveTab.sezioni) ? $filters.toEuroCurrency(TotaleCommissioniProgetto(ActiveTab.sezioni)) : '-'"
                :totaleCosti="ActiveTab && TotaleCostiEuroProgetto(ActiveTab.sezioni) ? $filters.toEuroCurrency(TotaleCostiEuroProgetto(ActiveTab.sezioni)) : '-'"
                :risorseInterne="dati_ultima_versione && dati_ultima_versione.risorse_interne ? dati_ultima_versione.risorse_interne : '-'"
                :utile="ActiveTab && TotaleUtiliProgetto(ActiveTab.sezioni).toLocaleValueString() ? $filters.toEuroCurrency(TotaleUtiliProgetto(ActiveTab.sezioni)) : '-'"
                :margine="ActiveTab && TotaleMolProgetto(ActiveTab.sezioni) ? `${TotaleMolProgetto(ActiveTab.sezioni).toLocaleValueString()} %` : '-'"
                :fee="ActiveTab && TotaleFeesSezioni(ActiveTab.sezioni).toLocaleValueString(2, 2)"
            ></SottoProgettoHead>
            <VersioneSottoProgetto
                v-for="(v, i) in versioni.rows"
                :key="i"
                class="pt-4 border-b-2 border-next-gray-md pb-2"
                :versione="{...v, data: JSON.parse(v.data)}"
                :sottoprogetto="sottoprogetto"
            >
            </VersioneSottoProgetto>
            <InfiniteLoading @infinite="versioni.fetchNextPage" :identifier="versioni.infiniteIdentifier" style="min-height: 1px">
                <template #complete>
                    <div class="text-center pb-3">Non ci sono altre versioni.</div>
                </template>
            </InfiniteLoading>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import Topbar from "../components/Topbar.vue";
import InfiniteLoading from "v3-infinite-loading";
import ContextMenu from "@/components/ContextMenu.vue";
import sottoProgettiManager from "../api/SottoProgetti";
import Loading from "@/components/Loading.vue";
import ModalSottoProgetto from "@/components/ModalSottoProgetto.vue";
import NextSottoProgettoTable from "@/components/NextSottoProgettoTable.vue";
import SezioneSottoProgetti from "@/components/SezioneSottoProgetti.vue";
import SottoProgettoHead from "@/views/SottoProgettoHead.vue";
import {mapActions, mapGetters} from 'vuex';
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import BadgeStato from "@/components/BadgeStato.vue";
import VersioneSottoProgetto from "@/components/VersioneSottoProgetto.vue";
import Checkbox from "@/components/Checkbox.vue";
import Lista from "@/setup/ListaCerca";
import {aziendeGruppoManager} from "../api/AziendeGruppo";

@Options({
    name:'VersioniSottoProgetto',
    components: {
        Checkbox,
        VersioneSottoProgetto,
        BadgeStato,
        Breadcrumbs,
        SottoProgettoHead,
        Topbar,
        NextSottoProgettoTable,
        ContextMenu,
        InfiniteLoading,
        ModalSottoProgetto,
        SezioneSottoProgetti,
        Loading
    },
    inject: ['getColoreStato'],
    props: {
        id: String,
    },
    computed: {
        ...mapGetters('sprjDataManager', [
            'TotaleCommissioniProgetto',
            'TotaleCostiEuroProgetto',
            'TotaleUtiliProgetto',
            'TotaleRicaviProgetto',
            'TotaleBudgetProgetto',
            'TotaleMolProgetto',
            'TotaleMol',
            'TotaleFeesSezioni',
            'ActiveTab',
        ]),
    },
    methods: {
        ...mapActions('sprjDataManager', [
            'setValute',
            'setFees',
            'setSottoprogetto',
            'setDatiSottoprogetto',
        ])
    }
})
export default class VersioniSottoProgetto extends Vue {
    id!: number | string
    loading = false

    TotaleCostiEuroProgetto: any;
    TotaleUtiliProgetto: any;
    TotaleRicaviProgetto: any;
    TotaleBudgetProgetto: any;
    TotaleCommissioniProgetto: any;
    TotaleMolProgetto: any;
    TotaleFeesSezioni: any;
    setDatiSottoprogetto: any;
    ActiveTab: any;
    setValute: any;
    setFees: any;

    sottoprogetto: any = {}
    paginatore: any = {}

    versioni: any = setup(()=>Lista(sottoProgettiManager,[],sottoProgettiManager.versioni))

    solo_manuali = false

    dati_ultima_versione: any = {}

    get getBreadcrumbsPath() {
        return  [
            {
                title: 'Progetti',
                name: 'ListaProgetti',
            },
            {
                title: 'Progetto',
                name: 'DettaglioProgetto',
                params: {id: this.sottoprogetto.progetto_id || 0}
            },
            {
                title: 'Sottoprogetto',
                name: 'DettaglioSottoProgetto',
                params: {id: this.id || 0}
            },
            {
                title: 'Versioni',
            },
        ]
    }

    created(){
        this.versioni.callBinds = [this.id]
    }

    onToggleManuali($event:any){
        this.solo_manuali = !this.solo_manuali
        this.versioni.apiParams['sm'] = this.solo_manuali?1:''
        this.versioni.reset()
    }

    mounted() {
        this.loading = true
        Promise.all([sottoProgettiManager.sottoprogetto(this.id).then((response) => {
            this.sottoprogetto = response.data;
            this.dati_ultima_versione = JSON.parse(response.data.ultimi_dati)
            this.setDatiSottoprogetto(this.dati_ultima_versione)
            this.setValute(this.dati_ultima_versione.valute)
            this.setFees(this.dati_ultima_versione.fee)
        }),
            this.versioni.reset()
        ]).then(()=>{
            return sottoProgettiManager.gamma(this.id)
        }).then((res)=>{
            this.sottoprogetto.stato = res.data.PD0C_STATO_PD1E
        }).finally(() => {
            this.loading = false
        })
    }

}

</script>


<style lang="scss">

</style>
